export const SET_CURRENT_TEMPLATE = 'SET_CURRENT_TEMPLATE'
